import { render, staticRenderFns } from "./ControlTable.vue?vue&type=template&id=19db8f40&scoped=true"
import script from "./ControlTable.vue?vue&type=script&lang=js"
export * from "./ControlTable.vue?vue&type=script&lang=js"
import style0 from "./ControlTable.vue?vue&type=style&index=0&id=19db8f40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19db8f40",
  null
  
)

export default component.exports